module.exports = __webpack_public_path__ + "img/1530999990.05e8eb77.jpg";